import toBlogPost from './toBlogPost';

const getBlogPost = async ({ slug, lang }) => {
  const langString = lang === 'de' ? '/de' : '';
  const url = `https://eyefitu.ch${langString}/wp-json/wp/v2/posts?_embed&slug=${slug}`;

  const response = await fetch(url);

  const [item] = await response.json();

  if (!item) {
    return null;
  }

  return toBlogPost(item);
};

export default getBlogPost;
